import { render, staticRenderFns } from "./number-response.vue?vue&type=template&id=c6e1b3c0&scoped=true&"
import script from "./number-response.vue?vue&type=script&lang=js&"
export * from "./number-response.vue?vue&type=script&lang=js&"
import style0 from "./number-response.vue?vue&type=style&index=0&id=c6e1b3c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e1b3c0",
  null
  
)

component.options.__file = "number-response.vue"
export default component.exports